import React, { Component, Fragment } from 'react'
import CheckAuth from '../../../utils/hoc/CheckAuth'
import LabelWithInput from '../../../components/molecules/LabelWithInput'
import { connect } from 'react-redux'
import Button from '../../../components/atoms/Button'
import UbahPass from '../../../redux/actions/UbahPass'
import InformationText from '../../../components/molecules/InformationText'
import RefreshToken from '../../../redux/actions/RefreshToken'
import TextBox from '../../../components/atoms/TextBox';
import Loading from '../../../components/molecules/Loading'

class UbahPassword extends Component {
    constructor (props) {
        super(props);

		this.state = {
            pass : '',
            newPass : '',
            reNewPass : '',
        }
    }

    onChangeValue = ({name, value}) => {
        this.setState({
            [name] : value
        });
    }

    onSubmitValue = () => {
        const {pass, newPass, reNewPass} = this.state;
        const {RefreshToken, SetError, ActionUbahPassword} = this.props;
        
        (pass === '' || newPass === '' || reNewPass === '') ? SetError('Semua field harus diisi.') :
        (newPass !== reNewPass) ? SetError('Kata Sandi Baru dan Konfirmasi Kata Sandi Baru tidak sesuai') :
        RefreshToken(ClientID => {
            //console.log(ClientID);
            if(ClientID){
                ActionUbahPassword(ClientID, {
                    oldPassword : pass,
                    newPassword : newPass
                }, (error) => { if(!error){this.onResetValue()} });
            }
		})
    }

    onResetValue = () => {
        this.setState({
            pass : '',
            newPass : '',
            reNewPass : ''
        })
    }
    

    componentDidMount = () =>{
        this.props.ResetStatusState();
		this.props.setTitlePage({
			title : 'Ubah Kata Sandi',
			breadcrumb : [
				{name : 'Beranda', url : '/dashboard', status : false},
				{name : 'Ubah Kata Sandi', url : '#', status : true}
			]
        })
    }
    
    render() {
        const {notif} = this.props;
        const {pass, newPass, reNewPass} = this.state;
        const {loading, error, success, successMsg, loadingPage} = this.props.status;
        const col = {
            label : 'col-12 col-lg-2 col-md-3',
            text : 'col-12 col-lg-10 col-md-9 mt-2 mt-md-0'
        };

        return (
            (notif.isLoadding || loadingPage) ? <Loading /> : (
                <form onSubmit={e => {e.preventDefault(); this.onSubmitValue()}} >
                    <LabelWithInput label='Kata Sandi Lama' col={col} {...this.props}>
                        <TextBox value={pass} type='password' name='pass' onChange={e => this.onChangeValue(e.target)} opts={{autoComplete : 'on'}} />
                    </LabelWithInput>

                    <LabelWithInput label='Kata Sandi Baru' col={col} {...this.props}>
                        <TextBox value={newPass} type='password' name='newPass' onChange={e => this.onChangeValue(e.target)} opts={{autoComplete : 'on'}} />
                    </LabelWithInput>

                    <LabelWithInput label='Konfirmasi Kata Sandi Baru' col={col} {...this.props}>
                        <TextBox value={reNewPass} type='password' name='reNewPass' onChange={e => this.onChangeValue(e.target)} opts={{autoComplete : 'on'}} />
                    </LabelWithInput>

                    <div className='bg-button add-margin'>
                        <Button title='SIMPAN' loading={loading} onClick={this.onSubmitValue} type='button' width='big' color='blue' />
                        <Button title='RESET' onClick={this.onResetValue} type='button' width='big' color='outline' />
                    </div>

                    { (success) && <InformationText value={successMsg} type={'success'} className='mt-3' /> }
                </form>
            )
        )
    }
}



const mapDispatchToProps = dispatch => {
	return { 
        ActionUbahPassword : (ClientID, data, cb) => {
            dispatch(UbahPass(ClientID, data, cb))
        }
    }
}
export default CheckAuth(connect(null, mapDispatchToProps)(UbahPassword));
